import { cva } from 'class-variance-authority';

export const selectorClasses = cva('flex w-full flex-col gap-3');

export const labelClasses = cva(
  [
    'rounded-lg-alt bg-white-50 flex w-full items-center justify-between gap-4 border-1 border-solid border-[#E6E6E6] p-4'
  ],
  {
    variants: {
      selected: {
        true: 'bg-cloud-200',
        false: ''
      },
      validationStatus: {
        true: ['border-success-500 focus:border-success-500'],
        false: ['border-danger-500 focus:border-danger-500'],
        undefined: ['border-stone-100 focus:border-stone-100']
      },
      disabled: {
        true: 'cursor-not-allowed opacity-50',
        false: ['cursor-pointer opacity-100', 'hover:bg-cloud-200']
      }
    }
  }
);

export const hiddenInputClasses = cva('absolute h-0 w-0 opacity-0');

export const contentClasses = cva('gap-1-5 flex flex-col');

export const checkboxIconClasses = cva('', {
  variants: {
    checked: {
      true: 'opacity-100',
      false: 'opacity-0'
    }
  }
});
